import type { HTMLAttributes, ReactNode } from 'react';

export interface CardProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  title?: ReactNode;
  /** Optional content rendered on the right side of the header. */
  headerActions?: ReactNode;
  footer?: ReactNode;
  children?: ReactNode;
}

export function Card({ title, headerActions, footer, children, className = '', ...rest }: CardProps) {
  return (
    <div className={`card ${className}`.trim()} {...rest}>
      {(title || headerActions) && (
        <div className="card-header d-flex align-items-center justify-content-between">
          <h5 className="card-title mb-0">{title}</h5>
          {headerActions && <div className="d-flex gap-2">{headerActions}</div>}
        </div>
      )}
      <div className="card-body">{children}</div>
      {footer && <div className="card-footer d-flex justify-content-end gap-2">{footer}</div>}
    </div>
  );
}
